import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';
import queryString from 'query-string';

// Loader Components
import showLoader from '@components/loader';

export const getViolations = createAsyncThunk('violationSlice/getViolations', async (data) => {
    try {
        // showLoader(true);
        const query = queryString.stringify(data);
        let response = await axios.get('/dashboard/vehicle-violations' + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const violationSlice = createSlice({
    name: 'violationSlice',
    initialState: {
        data: []
    },

    extraReducers: (builder) => {
        builder.addCase(getViolations.fulfilled, (state, action) => {
            state.data = action?.payload;
            return;
        });
    }
});

export default violationSlice.reducer;
